<template lang="pug">

#manage-user
    template
        v-tabs(v-model='tabs' fixed-tabs='')
            v-tabs-slider
            v-tab.primary--text(href='#man-users-1')
                v-icon vpn_key
            v-tab.primary--text(href='#man-users-2')
                v-icon person

        v-tabs-items(v-model='tabs')
            v-tab-item(key='1' value='man-users-1')
                v-card
                    CreateUsers
            v-tab-item(key='2' value='man-users-2')
                v-card
                    RegisterManage


</template>


<script>

import CreateUsers from './CreateUsers'
import RegisterManage from './RegisterManage'



  export default {
    components:{
        CreateUsers,
        RegisterManage
    },
    data () {
      return {
        tabs: null,
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      }
    },
  }
</script>